/*
 HotelTest

 Tresc regulaminu dla hotel-TEST
  
 historia: 
  PM 2021-12-08 - start
*/

import * as React from 'react';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Button, Theme, Typography } from '@material-ui/core';

class HotelTest extends React.Component<WithStyles<typeof styles>, any> {

    render() {
        const { classes } = this.props;
        if (document.title !== 'Rules and regulations') {
            document.title = 'Rules and regulations';
        }

        return (
            <React.Fragment>
                <Typography variant='h6' align="center"><b>Rules and regulations</b></Typography><br />
                <ol type="1">
                    <li><Typography variant='body2' gutterBottom>The apartments are rented for days, the day starts at 15.00 and ends at 11.00 on the last day of stay.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>The facility provides services in accordance with its standard. Current descriptions of individual apartments and their equipment can be found on the website of the facility <a href="https://hayduk.pl/home-2/" target="_blank" rel="noreferrer" className={classes.link}>
                        <Button
                            variant="text"
                            size="large"
                            className={`${classes.linkButton} ${classes.body2Button}`}
                        >
                            https://hayduk.pl
                        </Button>
                    </a>.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>The facility does not have a reception desk, all formalities are dealt with in the facility’s office.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>The facility provides: appropriate conditions for a comfortable stay of the guest, safety and confidentiality of the guest’s stay, friendly and professional service, cleaning of the apartment at the express request of the guest and replacement of towels during a stay longer than 1 day. Apartments are cleaned for longer stays once a week from Monday to Friday.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>The facility will take into account the request to extend the stay if possible, i.e. in the event that it has a free apartment.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>The guest cannot transfer the paid apartment to third parties, even if he has not used the entire paid stay.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Only adults can make reservations.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>In the case of staying with children, the guest is obliged to notify the host about this and submit an appropriate document confirming that he or she can stay with a minor, i.e. that he or she is the child's parent or guardian.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Children sleep on available beds.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>We do not accept animals in the facility.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Smoking is strictly prohibited in the apartments. For failure to comply with the ban, the Guest will be charged PLN 1,000.00 for losses incurred by the facility for neutralizing the smell of tobacco smoke and additional costs related to activating the fire protection system and the arrival of appropriate services - fine.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>The curfew is valid from 22.00 to 6 a.m.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>People who are not checked in the facility may stay on its premises from 6.00 to 20.00.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Guests are responsible for any damage caused to the rooms. Injury means both the destruction or damage to the room’s equipment as well as their loss.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>In the event of damage during the stay, the Guest is obliged to cover the costs of its repair. Parents are responsible for damages caused by children.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>The guest should notify the owners of the damage or its finding immediately after checking in and entering the apartment. Otherwise, the guest may be required to pay for damages.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Due to fire safety, it is forbidden to use electrical devices, e.g. irons, heaters and other not supplied apartments.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Guests are required to close the front door after each entry and / or exit to / from the facility.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>The facility is not responsible for damage to the guest’s vehicle (unguarded parking is available), as well as for valuables left in the apartments.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>The facility is not responsible for the loss or damage of items brought by the Guest to the extent specified in the provisions of the Civil Code in Art. 846 – 849 .</Typography></li>
                    <li><Typography variant='body2' gutterBottom>The facility does not accept valuables, money, securities and other expensive and valuable things in the deposit. In the event of their loss, destruction, the facility is not responsible.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Guests undertake to use the facility only for residential purposes – it is forbidden to organize events in the facility.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>In the event that the Guest significantly violates the peace and / or welfare of the neighbors and does not comply with the generally applicable standards of intercourse between people, the facility reserves the right to terminate the Guest’s stay and is then not obliged to refund the money for the unused period.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>The property reserves the right to refuse to rent apartments to returning guests who grossly violated the terms and conditions of their stay during their previous stay.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Booking an apartment means that you have read and accepted the above regulations.</Typography></li>
                </ol>
                
            
                {/* <br /><Typography variant='body2' gutterBottom>Rezerwacja apartamentu oznacza zapoznanie się i akceptację powyższego regulaminu.</Typography> */}
                <br /><Typography variant='body2' gutterBottom style={{fontSize: '16px'}}><b>We wish you a pleasant rest and we invite you again!</b></Typography>
            </React.Fragment>
        );
    }
}

const styles = (theme: Theme) => ({
    listItem: {
        display: 'list-item',
        marginLeft: theme.spacing(5),
    },
    listNone: {
        listStyleType: 'none'
    },
    breakSpaces: {
        whiteSpace: 'break-spaces' as 'break-spaces'
    },
    linkButton: {
        color: '#3a87ad',
        "&:hover": {
            textDecoration: "underline"
        }
    },
    h6Button: {
        padding: 0,
        fontSize: theme.typography.h6.fontSize,
        lineHeight: theme.typography.h6.lineHeight,
        letterSpacing: theme.typography.h6.letterSpacing,
        textTransform: 'none' as 'none',
        minWidth: 0,
        "&:hover": {
            background: 'none'
        }
    },
    body2Button: {
        padding: 0,
        fontSize: theme.typography.body2.fontSize,
        lineHeight: '16px',
        letterSpacing: theme.typography.body2.letterSpacing,
        textTransform: 'none' as 'none',
        minWidth: 0,
        "&:hover": {
            background: 'none'
        }
    },
    link: {
        textDecoration: 'none',
        lineBreak: 'anywhere' as 'anywhere'
    },
    alignCenter: {
        display: 'block',
        textAlign: 'center' as 'center'
    },
    bottomLabelFont: {
        fontSize: '16',
    }
});

export default withStyles(styles)(HotelTest);
